import { DAOItemType, IShellDAO } from './IShellDAO';
import { FindAllRepositoryItemsParams } from './types';
import { singleton } from 'tsyringe';

@singleton()
class ShellInMemoryDAOImpl implements IShellDAO {
  private store: Record<string, unknown> = {};

  findOne(key: string): unknown {
    try {
      return this.store?.[key];
    } catch (err) {
      return undefined;
    }
  }

  findAll(options?: FindAllRepositoryItemsParams): DAOItemType[] {
    const prefixKey = options?.prefixKey || '';
    return Object.keys(this.store)
      .filter((key) => key.startsWith(prefixKey))
      .map((key) => ({ key, value: this.findOne(key) }));
  }

  save(key: string, value: unknown): void {
    this.store[key] = value;
  }

  saveAll(key: string, values: unknown[]): void {
    this.save(key, values);
  }

  delete(key: string): boolean {
    if (this.store[key] !== undefined) {
      delete this.store[key];
      return true;
    }
    return false;
  }

  deleteAll(keys: string[]): void {
    keys.forEach((key) => {
      if (this.store[key] !== undefined) {
        delete this.store[key];
      }
    });
  }
}

export default ShellInMemoryDAOImpl;
